"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NoResult = function (props) {
    var icon = props.icon, title = props.title, description = props.description;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("i", { className: "cm-icon " + icon }),
            react_1.default.createElement("span", null, title),
            react_1.default.createElement("p", null,
                description,
                " "))));
};
exports.default = NoResult;
